import React from 'react';

import { SelectInput} from '@sogei/react-web-components-catalog'
import { observer, inject } from "mobx-react";
import i18next from 'i18next';



@inject("rootStore")
@observer
class SelectConservatorie extends React.Component {

  constructor(props) {
    super(props);
    this.tipologicaStore = props.rootStore.tipologicaStore;
  
  }

  componentDidMount() {
    this.tipologicaStore.fetchUfficioConservatorie("A",1,true);
    
  }

 

  render() {
   
    const sConservatorie = (props) => {
    const listaConservatorie = this.tipologicaStore.ufficioConservatorie;
      this.values = props.values;
      //console.log("this.values: ", JSON.stringify(this.values));
    

      //console.log("props: ", JSON.stringify(props));
      return (
        
        props.tipoPratica == 'UN' ?
        <div className='row'>
            <div className='col-sm-12 col-md-10 col-xl-10'>
            <SelectInput
                        id="conservatoria"
                        name="conservatoria"
                        value={this.values.conservatoria}
                        dimension="lg"
                        label={i18next.t("CONSERVATORIA")}
                        firstEmptyOption={true}
                        optionList={listaConservatorie}
                      
                        inputClass={[]}
                        labelClass={[]}
                        event={{
                        onChange:  props.onChange
                        }}

                        extraProps={{
                        
                        }}
                    />
            </div>
        </div>
        :null
      )

    }
    
    return (
        sConservatorie(this.props)

    );
  }

}




//export default SceltaTipoInvio;

export {SelectConservatorie}; 